import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { error, failedResponse, getBackendUrl, loaded, loading, LoadState, LoadStateInfo, notStarted } from "../../common";
import { MessageType } from "../messageListSlice";

export interface PureMessage {
	id: number,
	messageType?: MessageType,
    text?: string,
    contentId?: number,
}

export interface PureMessageRequest {
    messageId?: number;
}

export const retrievePureMessage = createAsyncThunk(
    "retrievePureMessage",
    async (param: PureMessageRequest, thunkAPI) => {
        console.debug("retrieve pure message");

        const token = (thunkAPI.getState() as RootState).user.token;

        const response = await fetch(`${getBackendUrl()}/api/conversation/massive/message/detail/${param.messageId}`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param, { getState }) => {
            const state = getState() as RootState;
            if(! state.user.token) {
                console.debug("No token, not loading massive message list");
                return false;
            }
            if (state.pureMessage.state.state === LoadState.NotStarted) {
                // Only load if never loaded before
                return true; 
            }
            return false;
        },
    }
);

export interface PureMessageState {
    state: LoadStateInfo;
    request?: PureMessageRequest;
    selected?: PureMessage;
}

const initialState: PureMessageState = {
    state: notStarted(),
};

export const pureMessageSlice = createSlice({
    name: "pureMessage",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
            state.selected = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrievePureMessage.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
                state.selected = undefined;
            })
            .addCase(retrievePureMessage.fulfilled, (state, action) => {
                state.state = loaded();
                state.selected = action.payload;
            })
            .addCase(retrievePureMessage.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

// export const { } = conversationListSlice.actions;

export const selectPureMessage = (state: RootState) => state.pureMessage;

export default pureMessageSlice.reducer;
